import React, { useState } from 'react'

export default function PlayersCount({currentCount, onChangePlayersCount}) {
  const counts = [10, 12, 14]

  const [customCount, setCustomCount] = useState('')
  const [isFocused, setIsFocused] = useState(false)
  const [customText, setCustomText] = useState(counts.includes(currentCount) ? '#' : currentCount)

  const onBlur = (e) => {
    if (isFocused) {
      setIsFocused(false)
      if (e.target.value != '') {
        onChangePlayersCount(customCount)
      }
      setCustomCount('')
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') e.target.blur()
  }

  const changeCount = (value) => {
    const intValue = parseInt(value)
    setCustomText(counts.includes(intValue) ? '#' : intValue)
    onChangePlayersCount(intValue)
  }

  const handleCusomCountChange = (e) => {
    const newCustomCount = Math.min(parseInt(e.target.value), 99)
    setCustomCount(newCustomCount)
    setCustomText(counts.includes(newCustomCount) ? '#' : newCustomCount)
  }

  return <div className='row'>
    <div className='col-sm-12'>
      <div className='reservation-players-amount'>
        { counts.map((number) =>
            <button key={number}
              className={`btn btn-lg btn-success number-btn ${currentCount === number ? 'active' : ''}`}
              onClick={() => changeCount(number)}>
              {number}
            </button>
          )}

        {
          isFocused ?
            <input
              type='number' min='1' step='1' autoFocus={true} name='players-amount-input'
              className='btn btn-lg btn-success number-btn active input--button'
              value={customCount}
              onChange={(e) => handleCusomCountChange(e) }
              onKeyDown={(e) => onKeyDown(e)}
              onBlur={(e) => onBlur(e)}
            />
          :
            <button
              className={`btn btn-lg btn-success number-btn ${customText === '#' ? '' : 'active'}`}
              onClick={() => setIsFocused(true)}>
              {customText}
            </button>
        }
      </div>
    </div>
    <div className='col-sm-4 text-center'> # of players </div>
  </div>
}
